export const getStartingNumber = (str) => {
    const match = str.match(/\d+/);
    return match ? parseInt(match[0]) : null;
};

export const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "short" }); // May
    const year = date.getFullYear();
    const time = date.toLocaleString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    }).toUpperCase(); // 12:40 PM

    return `${day} ${month} ${year} - ${time}`;
};

//export function formatDateTime(dateTimeStr) {
//    const date = new Date(dateTimeStr);

//    const day = date.getDate().toString().padStart(2, '0');

//    const month = date.toLocaleString('en-US', { month: 'short' }); // "Jun"

//    const year = date.getFullYear();

//    let hours = date.getHours();
//    const minutes = date.getMinutes().toString().padStart(2, '0');
//    const ampm = hours >= 12 ? 'PM' : 'AM';
//    hours = hours % 12 || 12; // convert 0 → 12
//    const formattedHours = hours.toString().padStart(2, '0');

//    return `${day} ${month} ${year} - ${formattedHours}: ${minutes} ${ampm}`;
//}


